﻿import { sdActionTriggerComponent, ActionTriggerHarnessController } from "./actionTrigger";
import { sdBreadcrumb, BreadcrumbHarnessController, DefaultBreadcrumbProviderFactory } from "./breadcrumb";
import { sdAlert, AlertHarnessController } from "./alert";
import { sdAreaPath, AreaPathHarnessController } from "./area-path";
import { sdButton, ButtonHarnessController } from "./button";
import { sdCheckbox, sdCheckboxGroup, CheckboxHarnessController } from "./checkbox";
import { sdCollectConfirmConclude, CollectConfirmConcludeHarnessController } from "./collect-confirm-conclude";
import { sdHeading, HeadingHarnessController } from "./heading";
import { sdInput, InputHarnessController } from "./input";
import { sdLabel, LabelHarnessController } from "./label";
import { sdLink, LinkHarnessController } from "./link";
import {
  sdActionMenu,
  sdActionMenuHover,
  MultiActionHarnessController,
  MultiActionHarness,
  sdMultiAction
} from "./multi-action";
import { sdMultiSelect, MultiSelectHarnessController } from "./multi-select";
import { sdPivot, sdPivots, PivotsHarnessController, sdPivotHeadingTransclude } from "./pivots";
import { sdMenu, sdPoppableMenu, PoppableMenuHarnessController } from "./poppable-menu";
import {
  sdPopper,
  sdPopperContent,
  sdPopperTrigger,
  PopperHarnessController,
  sdPopperRightClickTrigger,
  sdPopperHoverTrigger
} from "./popper";
import { sdProfileCard, ProfileCardHarnessController } from "./profile-card";
import { sdProgress, ProgressHarnessController } from "./progress";
import { sdQuickSelect, QuickSelectHarnessController } from "./quick-select";
import { sdRadio, sdRadioItemHtml, sdRadioItemText, RadioHarnessController } from "./radio";
import { sdSearch, SearchHarnessController } from "./search";
import { sdOption, sdSelect, SelectHarnessController } from "./select";
import { sdSelectMenu, sdSelectMenuReplaceWithTransclusion, SelectMenuHarnessController } from "./selectmenu";
import { sdTable, sdTableFilterGroup, sdTableFilterSelect, sdTableTestRandomHeightObject, sdColumn } from "./table";
// import "./section";
import { sdTextField, TextFieldHarnessController } from "./text-field";
import { sdTextarea, TextareaHarnessController } from "./textarea";
import { sdTileAction, TileActionHarnessController } from "./tileAction";
import { sdTile, sdTileLayout, sdTileGroup, TilelayoutHarnessController, sdTileRefreshStatus } from "./tileLayout";
import { sdWizard, sdWizardButton, sdWizardStep, WizardHarnessController } from "./wizard";
import { transcludeReplace } from "./sdTranscludeReplace";
import eaeControlsModule from "../eaeControls.module";
import { DialogHarnessController } from "./dialog/dialog.harness";
import { sdDialog } from "./dialog/dialog";
import { TableHarnessController, TabController, GlobalTableConstants } from "./table";
import { TileRefreshStatus, TileRefreshStatusFactory } from "./tileLayout/tiles";
import { sdDatePicker, DatePickerHarnessController } from "./datePicker";

eaeControlsModule
  .constant("tableConstants", new GlobalTableConstants())
  .service("tileRefreshStatus", TileRefreshStatus)
  .service("tileRefreshStatusFactory", TileRefreshStatusFactory)
  .component("sdActionTrigger", sdActionTriggerComponent)
  .controller("ActionTriggerHarnessController", ActionTriggerHarnessController)
  .service("defaultBreadcrumbProviderFactory", DefaultBreadcrumbProviderFactory)
  .component("sdBreadcrumb", sdBreadcrumb)
  .controller("BreadcrumbHarnessController", BreadcrumbHarnessController)
  .component("sdAlert", sdAlert)
  .controller("AlertHarnessController", AlertHarnessController)
  .component("sdAreaPath", sdAreaPath)
  .controller("AreaPathHarnessController", AreaPathHarnessController)
  .component("sdButton", sdButton)
  .controller("ButtonHarnessController", ButtonHarnessController)
  .component("sdCheckbox", sdCheckbox)
  .component("sdCheckboxGroup", sdCheckboxGroup)
  .controller("CheckboxHarnessController", CheckboxHarnessController)
  .component("sdCollectConfirmConclude", sdCollectConfirmConclude)
  .controller("CollectConfirmConcludeHarnessController", CollectConfirmConcludeHarnessController)
  .component("sdHeading", sdHeading)
  .controller("HeadingHarnessController", HeadingHarnessController)
  .component("sdInput", sdInput)
  .controller("InputHarnessController", InputHarnessController)
  .component("sdLabel", sdLabel)
  .controller("LabelHarnessController", LabelHarnessController)
  .component("sdLink", sdLink)
  .controller("LinkHarnessController", LinkHarnessController)
  .component("sdActionMenu", sdActionMenu)
  .component("sdActionMenuHover", sdActionMenuHover)
  .controller("MultiActionHarnessController", MultiActionHarnessController)
  .component("sdMultiAction", sdMultiAction)
  .component("sdMultiSelect", sdMultiSelect)
  .controller("MultiSelectHarnessController", MultiSelectHarnessController)
  .controller("PivotsHarnessController", PivotsHarnessController)
  .component("sdPivots", sdPivots)
  .directive("sdPivot", sdPivot)
  .directive("sdPivotHeadingTransclude", sdPivotHeadingTransclude)
  .component("sdMenu", sdMenu)
  .component("sdPoppableMenu", sdPoppableMenu)
  .controller("PoppableMenuHarnessController", PoppableMenuHarnessController)
  .component("sdPopper", sdPopper)
  .component("sdPopperContent", sdPopperContent)
  .component("sdPopperTrigger", sdPopperTrigger)
  .component("sdPopperRightClickTrigger", sdPopperRightClickTrigger)
  .component("sdPopperHoverTrigger", sdPopperHoverTrigger)
  .controller("PopperHarnessController", PopperHarnessController)
  .component("sdProfileCard", sdProfileCard)
  .controller("ProfileCardHarnessController", ProfileCardHarnessController)
  .component("sdProgress", sdProgress)
  .controller("ProgressHarnessController", ProgressHarnessController)
  .component("sdQuickSelect", sdQuickSelect)
  .controller("QuickSelectHarnessController", QuickSelectHarnessController)
  .component("sdRadio", sdRadio)
  .controller("RadioHarnessController", RadioHarnessController)
  .component("sdRadioItemText", sdRadioItemText)
  .component("sdRadioItemHtml", sdRadioItemHtml)
  .component("sdSearch", sdSearch)
  .controller("SearchHarnessController", SearchHarnessController)
  .component("sdSelect", sdSelect)
  .component("sdOption", sdOption)
  .controller("SelectHarnessController", SelectHarnessController)
  .component("sdSelectMenu", sdSelectMenu)
  .component("sdSelectMenuReplaceWithTransclusion", sdSelectMenuReplaceWithTransclusion)
  .controller("SelectmenuHarnessController", SelectMenuHarnessController)
  .directive("sdTable", sdTable)
  .directive("sdColumn", sdColumn)
  .component("sdTableFilterGroup", sdTableFilterGroup)
  .component("sdTableFilterSelect", sdTableFilterSelect)
  .component("sdTableTestRandomHeightObject", sdTableTestRandomHeightObject)
  .component("sdTextField", sdTextField)
  .controller("TextFieldHarnessController", TextFieldHarnessController)
  .component("sdTextarea", sdTextarea)
  .controller("TextareaHarnessController", TextareaHarnessController)
  .component("sdTileAction", sdTileAction)
  .controller("TileActionHarnessController", TileActionHarnessController)
  .component("sdTileLayout", sdTileLayout)
  .controller("TileLayoutHarnessController", TilelayoutHarnessController)
  .directive("sdTile", sdTile)
  .directive("sdTileGroup", sdTileGroup)
  .directive("sdTileRefreshStatus", sdTileRefreshStatus)
  .component("sdWizardButton", sdWizardButton)
  .component("sdWizardStep", sdWizardStep)
  .component("sdWizard", sdWizard)
  .controller("WizardHarnessController", WizardHarnessController)
  .directive("sdTranscludeReplace", transcludeReplace)
  .controller("DialogHarnessController", DialogHarnessController)
  .component("sdDialog", sdDialog)
  .controller("TableHarnessController", TableHarnessController)
  .controller("TabController", TabController)
  .directive("sdDatePicker", sdDatePicker)
  .controller("DatePickerHarnessController", DatePickerHarnessController)
  .run(MultiActionHarness);
